import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgEdit({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m21.099 13.677 2.608-3.327c1.82-2.32 4.875-2.398 7.236-.547l2.355 1.847c2.363 1.852 3.016 4.833 1.196 7.157L20.453 36.72a4.201 4.201 0 0 1-3.26 1.612l-5.417.07a1.694 1.694 0 0 1-1.671-1.311l-1.227-5.276c-.289-1.24 0-2.543.786-3.55l11.391-14.533a1.47 1.47 0 0 1 .044-.056Zm1.599 3.451L12.332 30.352a.824.824 0 0 0-.154.695l.916 3.949 4.057-.051a.815.815 0 0 0 .533-.206l.1-.108 10.369-13.227-5.455-4.276Zm7.545 1.61-5.455-4.277 1.584-2.02c.568-.724 1.49-.748 2.48.028l2.355 1.847c.991.777 1.188 1.675.62 2.401l-1.584 2.02Zm7.03 16.276a1.694 1.694 0 0 1 .197 3.377l-.197.011H26.468a1.694 1.694 0 0 1-.197-3.376l.198-.012h10.803Z"
            />
        </svg>
    )
}
SvgEdit.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgEdit
